import { useMediaQuery as useHooksUseMediaQuery } from 'usehooks-ts';

export enum ScreenBreakpoint {
  Mobile = '768px',
  Tablet = '979px',
  Laptop = '1200px',
}

export function useMediaQuery(size: ScreenBreakpoint): boolean {
  return useHooksUseMediaQuery(`(min-width: ${size})`);
}

export function useIsMobile(): boolean {
  return !useMediaQuery(ScreenBreakpoint.Mobile);
}

export function useIsTablet(): boolean {
  const mobileBreakpoint = useMediaQuery(ScreenBreakpoint.Mobile);
  const tabletBreakpoint = useMediaQuery(ScreenBreakpoint.Tablet);
  return tabletBreakpoint && !mobileBreakpoint;
}

export function useIsLaptop(): boolean {
  const tabletBreakpoint = useMediaQuery(ScreenBreakpoint.Tablet);
  const laptopBreakpoint = useMediaQuery(ScreenBreakpoint.Laptop);
  return tabletBreakpoint && !laptopBreakpoint;
}

export function useIsDesktop(): boolean {
  return useMediaQuery(ScreenBreakpoint.Laptop);
}

export function useIsLaptopOrDesktop(): boolean {
  const isLaptop = useIsLaptop();
  const isDesktop = useIsDesktop();
  return isLaptop || isDesktop;
}
